module.exports = __webpack_public_path__ + "static/media/mp4.b64ebf97.png";